/** Privacy policy — cookies section (section 9). */
export const PRIVACY_COOKIES_PATH = '/privacy#cookies';
